import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]

import { ref } from "@vue/reactivity";
import { useAuth0 } from "@auth0/auth0-vue";
import { useMutation } from "@vue/apollo-composable";
import gql from "graphql-tag";


export default /*#__PURE__*/_defineComponent({
  props: {
    bookmarked: { type: Boolean },
    uuid: null
  },
  setup(__props: any) {

const props = __props as {
  bookmarked: boolean,
  uuid: string,
}

const { user } = useAuth0();



let bookmarked = ref(props.bookmarked);

const { mutate: insertBookmark } = useMutation(
  gql`
    mutation InsertBookmark($post_uuid: uuid!, $user_id: String!) {
      insert_bookmark_one(
        object: { post_uuid: $post_uuid, user_id: $user_id }
      ) {
        uuid
      }
    }
  `
);

const { mutate: deleteBookmark } = useMutation(
  gql`
    mutation DeleteBookmark($post_uuid: uuid!, $user_id: String!) {
      delete_bookmark(
        where: { post_uuid: { _eq: $post_uuid }, user_id: { _eq: $user_id } }
      ) {
        affected_rows
      }
    }
  `
);

const onClick = () => {
  bookmarked.value = !bookmarked.value;
  const params = { post_uuid: props.uuid, user_id: user.value.sub };
  bookmarked.value ? insertBookmark(params) : deleteBookmark(params);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(["pi pi-bookmark cursor-hover hover:text-primary", { 'text-primary': _unref(bookmarked) }]),
    onClick: _withModifiers(onClick, ["stop"])
  }, null, 10, _hoisted_1))
}
}

})